
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91route_93X3w7JEbHKlMeta } from "/var/www/frontend/c-rent-client-vue/pages/[route].vue?macro=true";
import { default as _404SMs8JmcW8iMeta } from "/var/www/frontend/c-rent-client-vue/pages/404.vue?macro=true";
import { default as about_45us6tixdCb2xMMeta } from "/var/www/frontend/c-rent-client-vue/pages/about-us.vue?macro=true";
import { default as adszXW7OQjf5WMeta } from "/var/www/frontend/c-rent-client-vue/pages/ads.vue?macro=true";
import { default as indexfKeftTMzReMeta } from "/var/www/frontend/c-rent-client-vue/pages/bike/[slug]/index.vue?macro=true";
import { default as indexm2oGrBkjr1Meta } from "/var/www/frontend/c-rent-client-vue/pages/bike/index.vue?macro=true";
import { default as indexeLkeysrbTrMeta } from "/var/www/frontend/c-rent-client-vue/pages/blog/[id]/index.vue?macro=true";
import { default as indexyg1rAKu5ouMeta } from "/var/www/frontend/c-rent-client-vue/pages/blog/index.vue?macro=true";
import { default as _91extend_id_93zgHklNRT4QMeta } from "/var/www/frontend/c-rent-client-vue/pages/booking/[id]/extend/[extend_id].vue?macro=true";
import { default as indexYSt35FARjeMeta } from "/var/www/frontend/c-rent-client-vue/pages/booking/[id]/extend/index.vue?macro=true";
import { default as indexrljDsusNGjMeta } from "/var/www/frontend/c-rent-client-vue/pages/booking/[id]/index.vue?macro=true";
import { default as indexj4ckic8CK3Meta } from "/var/www/frontend/c-rent-client-vue/pages/booking/index.vue?macro=true";
import { default as faqaIR1ZuUyVgMeta } from "/var/www/frontend/c-rent-client-vue/pages/faq.vue?macro=true";
import { default as galleryT8Wqm2tSLqMeta } from "/var/www/frontend/c-rent-client-vue/pages/gallery.vue?macro=true";
import { default as indexw0SSEUOcJsMeta } from "/var/www/frontend/c-rent-client-vue/pages/history/[id]/index.vue?macro=true";
import { default as indexLyVTd0AtMfMeta } from "/var/www/frontend/c-rent-client-vue/pages/history/index.vue?macro=true";
import { default as indexJhGXC9MnHcMeta } from "/var/www/frontend/c-rent-client-vue/pages/index.vue?macro=true";
import { default as meGLKzu5SMlnMeta } from "/var/www/frontend/c-rent-client-vue/pages/me.vue?macro=true";
import { default as _91id_93k1L4VKQ3jtMeta } from "/var/www/frontend/c-rent-client-vue/pages/payment/[id].vue?macro=true";
import { default as privacy_45policyU4XrdBS8TLMeta } from "/var/www/frontend/c-rent-client-vue/pages/privacy-policy.vue?macro=true";
import { default as _91id_935WMRsQOOQpMeta } from "/var/www/frontend/c-rent-client-vue/pages/reservation/[id].vue?macro=true";
import { default as terms_45of_45serviceHKxtvmC36yMeta } from "/var/www/frontend/c-rent-client-vue/pages/terms-of-service.vue?macro=true";
import { default as indexo7Zp4Uxtx7Meta } from "/var/www/frontend/c-rent-client-vue/pages/tour-package/[slug]/index.vue?macro=true";
import { default as indexsmgA5OX9H3Meta } from "/var/www/frontend/c-rent-client-vue/pages/tour-package/index.vue?macro=true";
import { default as _91id_93rLaj0chrjCMeta } from "/var/www/frontend/c-rent-client-vue/pages/tour-reservation/[id].vue?macro=true";
import { default as indexGAUcWEOp87Meta } from "/var/www/frontend/c-rent-client-vue/pages/transaction-status/index.vue?macro=true";
import { default as transaction7okmI6WiIsMeta } from "/var/www/frontend/c-rent-client-vue/pages/transaction.vue?macro=true";
import { default as component_45stubCK7m1lvUJwMeta } from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubCK7m1lvUJw } from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "route___en",
    path: "/:route()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/[route].vue")
  },
  {
    name: "404___en",
    path: "/404",
    meta: _404SMs8JmcW8iMeta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/404.vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/about-us.vue")
  },
  {
    name: "ads___en",
    path: "/ads",
    meta: adszXW7OQjf5WMeta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/ads.vue")
  },
  {
    name: "bike-slug___en",
    path: "/bike/:slug()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/bike/[slug]/index.vue")
  },
  {
    name: "bike___en",
    path: "/bike",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/bike/index.vue")
  },
  {
    name: "blog-id___en",
    path: "/blog/:id()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/blog/[id]/index.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/blog/index.vue")
  },
  {
    name: "booking-id-extend-extend_id___en",
    path: "/booking/:id()/extend/:extend_id()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/booking/[id]/extend/[extend_id].vue")
  },
  {
    name: "booking-id-extend___en",
    path: "/booking/:id()/extend",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/booking/[id]/extend/index.vue")
  },
  {
    name: "booking-id___en",
    path: "/booking/:id()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/booking/[id]/index.vue")
  },
  {
    name: "booking___en",
    path: "/booking",
    meta: indexj4ckic8CK3Meta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/booking/index.vue")
  },
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/faq.vue")
  },
  {
    name: "gallery___en",
    path: "/gallery",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/gallery.vue")
  },
  {
    name: "history-id___en",
    path: "/history/:id()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/history/[id]/index.vue")
  },
  {
    name: "history___en",
    path: "/history",
    meta: indexLyVTd0AtMfMeta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/history/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexJhGXC9MnHcMeta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/index.vue")
  },
  {
    name: "me___en",
    path: "/me",
    meta: meGLKzu5SMlnMeta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/me.vue")
  },
  {
    name: "payment-id___en",
    path: "/payment/:id()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/payment/[id].vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/privacy-policy.vue")
  },
  {
    name: "reservation-id___en",
    path: "/reservation/:id()",
    meta: _91id_935WMRsQOOQpMeta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/reservation/[id].vue")
  },
  {
    name: "terms-of-service___en",
    path: "/terms-of-service",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/terms-of-service.vue")
  },
  {
    name: "tour-package-slug___en",
    path: "/tour-package/:slug()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/tour-package/[slug]/index.vue")
  },
  {
    name: "tour-package___en",
    path: "/tour-package",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/tour-package/index.vue")
  },
  {
    name: "tour-reservation-id___en",
    path: "/tour-reservation/:id()",
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/tour-reservation/[id].vue")
  },
  {
    name: "transaction-status___en",
    path: "/transaction-status",
    meta: indexGAUcWEOp87Meta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/transaction-status/index.vue")
  },
  {
    name: "transaction___en",
    path: "/transaction",
    meta: transaction7okmI6WiIsMeta || {},
    component: () => import("/var/www/frontend/c-rent-client-vue/pages/transaction.vue")
  },
  {
    name: component_45stubCK7m1lvUJwMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubCK7m1lvUJw
  }
]